var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_120_59)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33333 21H18.6667C19.9553 21 21 19.9553 21 18.6667V2.33333C21 1.04467 19.9553 0 18.6667 0H2.33333C1.04467 0 0 1.04467 0 2.33333V18.6667C0 19.9553 1.04467 21 2.33333 21Z",
    fill: "#007EBB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0834 18.0833H14.9671V12.7756C14.9671 11.3204 14.4141 10.5072 13.2623 10.5072C12.0093 10.5072 11.3546 11.3535 11.3546 12.7756V18.0833H8.35141V7.97222H11.3546V9.33419C11.3546 9.33419 12.2576 7.66331 14.4033 7.66331C16.5479 7.66331 18.0834 8.97297 18.0834 11.6816V18.0833ZM4.76858 6.64826C3.74562 6.64826 2.91669 5.81282 2.91669 4.78246C2.91669 3.75211 3.74562 2.91667 4.76858 2.91667C5.79154 2.91667 6.61998 3.75211 6.61998 4.78246C6.61998 5.81282 5.79154 6.64826 4.76858 6.64826ZM3.21785 18.0833H6.34943V7.97222H3.21785V18.0833Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_120_59"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn1);
export default __webpack_public_path__ + "static/media/LinkedIn 1.d63d45221045a7d3ea37bad533c6d61c.svg";
export { ForwardRef as ReactComponent };